import { render, staticRenderFns } from "./MenuSettings.vue?vue&type=template&id=38da663b&"
import script from "./MenuSettings.vue?vue&type=script&lang=js&"
export * from "./MenuSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports